import * as betprofessor from './TopNav.styles.betprofessor';
import * as betroyale from './TopNav.styles.betroyale';
import * as fiestabet from './TopNav.styles.fiestabet';
import * as goldenrush from './TopNav.styles.goldenrush';
import * as juicybet from './TopNav.styles.juicybet';
import * as puntcity from './TopNav.styles.puntcity';
import * as puntgenie from './TopNav.styles.puntgenie';
import * as questbet from './TopNav.styles.questbet';
import * as sterlingparker from './TopNav.styles.sterlingparker';
import * as vikingbet from './TopNav.styles.vikingbet';
import * as volcanobet from './TopNav.styles.volcanobet';
import * as forsport from './TopNav.styles.forsport';
import * as junglebet from './TopNav.styles.junglebet';
import * as oldgill from './TopNav.styles.oldgill';
import * as sugarcastle from './TopNav.styles.sugarcastle';
import * as betgalaxy from './TopNav.styles.betgalaxy';
import * as buffalobet from './TopNav.styles.buffalobet';
import * as titanbet from './TopNav.styles.titanbet';
import * as slambet from './TopNav.styles.slambet';
import * as gigabet from './TopNav.styles.gigabet';
import * as betstride from './TopNav.styles.betstride';
import * as templebet from './TopNav.styles.templebet';
import * as goldenbet888 from './TopNav.styles.goldenbet888';
import * as hyperbet from './TopNav.styles.hyperbet';
import * as bet777 from './TopNav.styles.bet777';
import * as chromabet from './TopNav.styles.chromabet';
import * as bet575 from './TopNav.styles.bet575';
import * as epicodds from './TopNav.styles.epicodds';
import * as pyramidbet from './TopNav.styles.pyramidbet';
import * as magnumbet from './TopNav.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  forsport,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
